import React, { lazy, Suspense, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styles from './App.module.css';
import Navbar from './components/Navbar';
import { usePageTracking } from './hooks/useAnalytics';
import { useEngagementTracking } from './hooks/useEngagementTracking';

import Sandbox from './components/Sandbox';
import Experimental from './components/Experimental';
import Music from './components/Music';
import MoviePage from './components/MoviePage';
import Film from './components/Film';
import Home from './components/Home';
import News from './components/News';
import EditProfile from './components/DevPortfolio/profile/EditProfile';
import Lilly from './components/Lilly';
import Lumberjack from './components/Lumberjack';

const Admin = lazy(() => import('./components/Admin'));
const AlbumCreate = lazy(() => import('./components/AlbumCreate'));
const AlbumPage = lazy(() => import('./components/AlbumPage'));
const AlbumEdit = lazy(() => import('./components/AlbumEdit'));
const AlbumList = lazy(() => import('./components/AlbumList'));
const Bio = lazy(() => import('./components/Bio'));
const Commercial = lazy(() => import('./components/Commercial'));
const Collaborations = lazy(() => import('./components/Collaborations'));
const Contact = lazy(() => import('./components/Contact'));
const DevPortfolio = lazy(() => import('./components/DevPortfolio/DevPortfolio'));
const LuxuryAesthetic = lazy(() => import('./components/LuxuryAesthetic'));
const TrackList = lazy(() => import('./components/TrackList'));
const TrackEdit = lazy(() => import('./components/TrackEdit'));
const VideoList = lazy(() => import('./components/VideoList'));
const Zphoto = lazy(() => import('./components/Zphoto'));
const ZphotoList = lazy(() => import('./components/ZphotoList'));
const Alma = lazy(() => import('./components/Alma'));
const JSLRNRT = lazy(() => import('./components/JSLRNRT'));
const TFAAF = lazy(() => import('./components/TFAAF'));

function AppShell({ selectedTrack, setSelectedTrack, handleTrackSelect, changeTrack }) {
  usePageTracking();
  useEngagementTracking();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/albumlist" element={<AlbumList />} />
        <Route path="/albumcreate" element={<AlbumCreate />} />
        <Route
          path="/AlbumEdit/:id"
          element={
            <AlbumEdit
              selectedTrack={selectedTrack}
              setSelectedTrack={setSelectedTrack}
              handleTrackSelect={handleTrackSelect}
              changeTrack={changeTrack}
            />
          }
        />
        <Route path="/AlbumPage/:albumid" element={<AlbumPage />} />
        <Route path="/bio" element={<Bio />} />
        <Route path="/collaborations" element={<Collaborations />} />
        <Route path="/commercial" element={<Commercial />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/devPortfolio" element={<DevPortfolio />} />
        <Route path="/EditProfile/:id" element={<EditProfile />} />
        <Route path="/film/*" element={<Film />} />
        <Route path="/music/*" element={<Music />} />
        <Route path="/news" element={<News />} />
        <Route path="/Sandbox" element={<Sandbox />} />
        <Route path="/experimental" element={<Experimental />} />
        <Route path="/MoviePage" element={<MoviePage />} />
        <Route path="/Alma" element={<Alma />} />
        <Route path="/JSLRNRT" element={<JSLRNRT />} />
        <Route path="/TFAAF" element={<TFAAF />} />
        <Route path="/Lumberjack" element={<Lumberjack />} />
        <Route path="/Lilly" element={<Lilly />} />
        <Route path="/LuxuryAesthetic" element={<LuxuryAesthetic />} />
        <Route path="/tracklist" element={<TrackList />} />
        <Route path="/TrackEdit/:id" element={<TrackEdit />} />
        <Route path="/videolist" element={<VideoList />} />
        <Route path="/zphoto" element={<Zphoto />} />
        <Route path="/zphotolist" element={<ZphotoList />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  const [selectedTrack, setSelectedTrack] = useState(null);

  return (
    <div className={styles.App}>
      <Router>
        <Navbar />
        <div className={styles.content}>
          <AppShell
            selectedTrack={selectedTrack}
            setSelectedTrack={setSelectedTrack}
            handleTrackSelect={setSelectedTrack}
            changeTrack={setSelectedTrack}
          />
        </div>
      </Router>
    </div>
  );
}

export default App;
